<template>
    
<div>

    <page-padding>
        <spinner v-if="showLoader && !hasAbsences" class="spinner-custom" />
        <div v-if="!showLoader && !hasAbsences && appSettings.modules.absences=='1'">{{$t('language.no_absences')}}</div>
        
        
        <div v-if="hasAbsences">
         <div v-for='(item,index) in sliceArray(absences["0absences"].filter(item=>item.absences.length),3)' :key="index">
          <!-- button for child itself -->
          <featured-button v-if="item.absences.length" iconBg="#FF0000" iconRight="" :title="getTitle(item)" subtitle="">
            <div slot="icon-left">
              <ui-icon icon="user" backgroundColor="transparent" :color="getColor(item)"/>
            </div>
          </featured-button>
          <!-- button multiple absences for child -->
          <featured-button v-for="(absence, index) in item.absences" :title="absence.reason" :subtitle="getSubtitle(absence)" :key="index" iconRight="" @click.native="clickAbsence(item, absence)">
            <div slot="icon-left">
              <ui-icon icon="thermometer" backgroundColor="transparent" color="#666666"/>
            </div>
          </featured-button>
            
          </div>
          <button-more title="language.view_more_absences" to="group/0/absences"/>
        </div>
      </page-padding>

</div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import Spinner from '../../components/Spinner';
import ButtonMore from '../../components/buttons/ButtonMore';
import FeaturedButton from '../../components/buttons/FeaturedButton';
import UiIcon from '../UiIcon.vue';
import { USER_LEVEL } from '../../settings/USER_LEVEL.js';
import { helper } from '../../services/Helper.js';
import { absenceSettings } from '../../settings/AbsenceSettings.js';

export default {
  name: 'list-absence-featured',
  props:{
  },
  data:function(){
    return {
      showLoader:false,
    }
  },
  components:{
    PagePadding,
    Spinner,
    ButtonMore,
    FeaturedButton,
    UiIcon,
  },
  methods:{
    getTitle(item){
      var title=item.name;
      
      return helper.decodeHtml(title);
    },
    getSubtitle(absence){

        return absenceSettings.getDurationText(absence.duration)
       
    },
    goToInfo(){
      // go to group absence and display info about absence guidelines
      //this.$router.push({path:"/absence-module-disabled/"})
    },
     formatDate(date){
      var year=date.getFullYear();
      var month=(date.getMonth()+101).toString().slice(-2);
      var day=(date.getDate()+100).toString().slice(-2);
      // set date?
      return year+"-"+month+"-"+day;

    },
    reportChildFit(item){

     
      // child is better
      var today=new Date();
      var date= this.formatDate(today)

      var payload={
          store_key:"0absences",
          id:item.id,
          date:date,
        }

        this.$store.dispatch('delete_absence',payload).then(
          ()=>{}
        )
    },
    clickAbsence(child, absence){
     
       // if user is parent then go to update
      switch(this.appSettings.user_level){
        case USER_LEVEL.PARENT:
          // just view absence, no update from parent
          this.$router.push({path:"group/"+child.group_id+"/absence/view/"+absence.id})
        break;
        case USER_LEVEL.ADMIN:
          // beter melden
          this.reportChildFit(absence);
        break;
        case USER_LEVEL.TEACHER:
          // beter melden
           this.reportChildFit(absence);
        break;
      }
     
    },
    getColor(item){
      if (item.absence){
        return "#FF0000";
      }else{
        return "#8cc63e"
      }
    },
    sliceArray(arr,count){
      if(arr){
        return arr.slice(0,count)
      }else{
        return [];
      }
    },
    loadAbsences(){
       this.showLoader=true;
       this.$store.dispatch('get_absences',{store_key:"0absences",group_id:0}).then(()=>{
       this.showLoader=false;
    })
    }
  },
  computed:{
    ...mapState([
       'absences','loaded','appSettings'
       ]),
       hasAbsences:function(){

         // loop throug list of children to see if there any are absent..
         var result=false;

         if(!this.absences["0absences"]){
          return ;
         }
         
         this.absences["0absences"].forEach(child=>{
           if(child.absences.length){
            result=true;
           }
         })


         return result;
       },
       
  },
  created:function(){
   this.loadAbsences();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.spinner-custom{
  margin:10px 0;
}
</style>

